import React, { createContext, useContext, useEffect, useState } from 'react';
import { app, db } from '../config/firebaseConfig';

const FirebaseContext = createContext(null);

export const FirebaseProvider = ({ children }) => {
    const [isInitialized, setIsInitialized] = useState(false);

    useEffect(() => {
        const initFirebase = async () => {
            try {
                // Simple check if Firebase is initialized
                if (app && db) {
                    setIsInitialized(true);
                }
            } catch (error) {
                console.error('Firebase initialization error:', error);
            }
        };

        initFirebase();
    }, []);

    // Don't show loading for public routes
    if (!isInitialized) {
        return children; // Just render children while initializing
    }

    return (
        <FirebaseContext.Provider value={{ app, db }}>
            {children}
        </FirebaseContext.Provider>
    );
};

export const useFirebase = () => {
    const context = useContext(FirebaseContext);
    if (!context) {
        throw new Error('useFirebase must be used within a FirebaseProvider');
    }
    return context;
}; 